import { Content } from "../../squidex";

export class ResourceModel extends Content {

    constructor(current?: Content) {
        super(current);
    }
}
